var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ManagerAdvancedFilter", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showAdditionalFilters,
            expression: "showAdditionalFilters",
          },
        ],
        attrs: { shouldClearFilters: _vm.shouldClearFilters },
        on: {
          filtersChanged: _vm.handleFiltersChanged,
          appliedFiltersNumberChanged: _vm.handleAppliedFiltersNumberChanged,
          filtersReset: function ($event) {
            return _vm.$emit("filtersReset")
          },
          rangeStart: _vm.handleTimeRangeChanged,
          rangeEnd: _vm.handleTimeRangeChangedEnd,
          close: _vm.handleIconClose,
        },
      }),
      _c(
        "scheduler-overlay",
        {
          attrs: {
            type: _vm.type,
            isLoading: _vm.loading,
            hasData: !!_vm.managerProjects.length,
            customPlaceholderMessage: _vm.customPlaceholderMessage,
          },
        },
        [
          _c("scheduler", {
            attrs: {
              filterBy: _vm.type,
              managers: _vm.managerWithProjects,
              managerProjects: _vm.managersForGroups,
              customOptions: _vm.options,
              currentUser: _vm.currentUser,
              schedulerView: "managers",
              companyId: _vm.companyId,
            },
            on: {
              rangechanged: _vm.rangeChanged,
              select: _vm.handleSelect,
              next: _vm.nextValue,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }